import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

const isLocalDev = typeof window !== 'undefined'
    && /localhost|127\.0\.0\.1/.test(window.location.hostname);

// Dev: never keep a service worker — stale chunks become index.html → "Unexpected token '<'".
if ('serviceWorker' in navigator && isLocalDev) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.getRegistrations()
            .then((regs) => Promise.all(regs.map((r) => r.unregister())))
            .then(() => {
                if (typeof caches !== 'undefined') {
                    return caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k))));
                }
                return undefined;
            })
            .catch(() => {});
    });
} else if ('serviceWorker' in navigator) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Reloading while offline often blanks the app (uncached chunks). Defer until online.
        if (typeof navigator !== 'undefined' && !navigator.onLine) return;
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
    });

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then((reg) => {
                const activateWaiting = (worker) => {
                    worker?.postMessage({ type: 'SKIP_WAITING' });
                };
                if (reg.waiting) activateWaiting(reg.waiting);
                reg.addEventListener('updatefound', () => {
                    const installing = reg.installing;
                    installing?.addEventListener('statechange', () => {
                        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                            activateWaiting(installing);
                        }
                    });
                });
            })
            .catch(() => {
                // App still works without SW (private mode / blocked SW)
            });
    });
}
